<svelte:head>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css">
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.7.0/font/bootstrap-icons.css">
</svelte:head>

<script>
  window.console.log = console.log
  window.istelog = console.log
  window.console.log = () => {}

  import { Form, FormGroup, FormText, Input, Label, Button } from 'sveltestrap';
  import { Card, CardBody,CardFooter, CardHeader, CardSubtitle, CardText, CardTitle} from 'sveltestrap';  
  import { Col, Container, Row  } from 'sveltestrap';
  
  const _api = '/v1'
  const LOGIN_URL = _api + "/login"
  const CHANGEPWD_URL = _api + "/changepwd"
  let username = ""
  let password = ""
  let newpassword1 = ""
  let newpassword2 = ""
  let changePasswordFlag = false

  const sendLogin = (e) => {
        e.preventDefault();
        console.log('USER ', username)
        console.log('PASS ', password)

        const login_data = { username:username, pass:password}

        fetch(LOGIN_URL, {
        method: "POST",
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
        },           
        body: JSON.stringify(login_data)        
        })
        .then(response => {
          
          console.log('Response',response)
          
          if (response.status === 200)
            {

                if (response.url.includes('wronglogin'))
                    {
                      console.log('Wrong Login')
                    }
                else
                    {
                      location.replace(response.url)
                    }
            }           
          })                
        .catch(error => {
            console.log('login error 2', error)                
        });
    }

  const changePassword = (e) => {
        e.preventDefault();
        changePasswordFlag = true
    }

  const changePasswordSubmit = (e) => {
        e.preventDefault();
        console.log('CHANGE PASSWORD')
        console.log('USER ', username)
        console.log('PASS ', password)
        console.log('NEWPASS ', newpassword1)
        console.log('NEWPASS2 ', newpassword2)
        e.preventDefault();
        console.log('USER ', username)
        console.log('PASS ', password)

        if (newpassword1 !== newpassword1)
            {
            console.log('Password do not match')
            //Modal
            return
            }
        else {
          const login_data = { username:username, pass:password,  newpass:newpassword1 }

          fetch(CHANGEPWD_URL, {
          method: "POST",
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
          },           
          body: JSON.stringify(login_data)        
          })
          .then(response => response.json())        
          .then(data => {                 
                console.log('chengepwd data', data)                
                })          
          .catch(error => {
              console.log('change password error', error)                
          });

          changePasswordFlag = false
        }
    }
    
    const changePasswordCancel = (e) => {
        e.preventDefault();
        changePasswordFlag = false
    }

</script>
  
<Container>
  <!-- <Row> <div>&nbsp;</div></Row> -->
  <Row text-center>
      <h2 class="display-4 d-flex align-items-center justify-content-center" style="color: purple; font-weight: 200; letter-spacing: 0.2rem;font-weight:bold">
        Video Wall control  
      </h2>
    </Row>

  <Row>
    <Col sm="3">&nbsp;</Col>
    <Col sm="6"><Card class="mb-3">
      <CardBody>    
      <Form autocomplete="off"> <FormGroup>
          <Label for="username">Username</Label>
          <Input id="username" name=""   type="text" bind:value={username} />
          <Label for="password">Password</Label>
          <Input id="password" placeholder="******" type="password"  autocomplete=’off’ bind:value={password} />
          {#if !changePasswordFlag}   
          <Button class="mt-3 mb-2" block color="secondary" on:click={sendLogin}>Login </Button>
          <span class="text-muted" on:click={changePassword}> Password change </span>
          {:else}
          <Label for="newpassword1">New password</Label>
          <Input id="newpassword1" placeholder="******" type="password" bind:value={newpassword1} autocomplete=’off’/>
          <Label for="newpassword2">New password again</Label>
          <Input id="newpassword2" class="form-control" placeholder="******" type="password" bind:value={newpassword2} autocomplete=’off’ />

          <Row>
            <Col sm="6"><Button class="mt-3 mb-2" block color="secondary" on:click={changePasswordSubmit}>Change password </Button></Col>
            <Col sm="6"><Button class="mt-3 mb-2" block color="secondary" on:click={changePasswordCancel}>Cancel </Button></Col>
          </Row>
          {/if}

      </FormGroup></Form></CardBody>
    </Card></Col>
    <Col sm="3">&nbsp;</Col>
  </Row>

</Container>
